import { Component, OnInit } from '@angular/core';
import { PaginatedData } from 'src/app/models/paginatedData';
import { PaginationObject } from 'src/app/models/paginationObject';
import { CreatePersonaComponent } from '../create-persona/create-persona.component';
import { ImportPersonaComponent } from '../import-persona/import-persona.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'apc-dashboard-account',
  templateUrl: './account.component.html',
  styleUrls: ['../dashboard.component.scss']
})
export class DashboardAccountComponent {
  public data: PaginatedData;
  public pagination = new PaginationObject();
  public navigation = [
    { link: '/dashboard', svg: 'assets/ico/arrow-to-left-regular.svg', title: 'BACK' },
    {
      link: 'general',
      svg: 'assets/ico/account_box.svg',
      title: 'dashboard.menu.accountsSubmenu.general.title',
      permission: { section: 'account', subsection: 'general', pertinence: 'subsection', context: 'metadata', type: 'READER' },
    },
  ];

  
  constructor(private modalService: NgbModal) {}
  public createPersonaModalRef: NgbModalRef;
  public importPersonaModalRef: NgbModalRef;

  public buttons = [
    {
      key: 'create',
      svg: 'assets/ico/user-regular.svg',
      permission: {
        pertinence: 'persona',
        section: 'profile',
        context: 'create',
        type: 'MANAGER',
      },
      tooltipMessageKey: 'dashboard.persona.new.button',
    },
    {
      key: 'import',
      svg: 'assets/ico/import-persona.svg',
      permission: {
        pertinence: 'persona',
        section: 'profile',
        context: 'import',
        type: 'MANAGER',
      },
      tooltipMessageKey: 'dashboard.persona.new.import',
    },
  ];

  createElement(key: string) {
    if (key == 'create') {
      this.createPersonaModalRef = this.modalService.open(CreatePersonaComponent, {
        ariaLabelledBy: 'modal-basic',
        backdrop: 'static',
        keyboard: false,
      });
      this.createPersonaModalRef.componentInstance.modalRef = this.createPersonaModalRef;
    } else if (key == 'import') {
      this.importPersonaModalRef = this.modalService.open(ImportPersonaComponent, {
        ariaLabelledBy: 'modal-basic',
        backdrop: 'static',
        keyboard: false,
      });
      this.importPersonaModalRef.componentInstance.modalRef = this.importPersonaModalRef;
    }
  }

}
